import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import { floatingToolbarItemStyles } from "./floatingToolbarStyles";
import { useMobileBadge } from "./FloatingToolbar";

const useStyles = makeStyles(floatingToolbarItemStyles);

const positionClassMap = {
  first: "itemFirst",
  last: "itemLast",
  only: "itemOnly",
  middle: "itemMiddle",
};

export default function FloatingToolbarItem({
  icon,
  label,
  mobileLabel,
  badge,
  badgeDot,
  tooltip,
  tooltipTitle,
  tooltipOpen,
  onTooltipOpen,
  onTooltipClose,
  onClick,
  children,
  _position,
  _mobile,
}) {
  const classes = useStyles();
  const badgeLabel = badge > 99 ? "99+" : badge;

  useMobileBadge(badge || (badgeDot ? 1 : 0));

  if (_mobile) {
    return (
      <div className={classes.mobileItem} onClick={onClick}>
        <span className={classes.mobileIcon}>{icon}</span>
        <span className={classes.mobileLabel}>{mobileLabel || label}</span>
        {badge > 0 && (
          <Badge
            badgeContent={badge}
            color="error"
            overlap="rectangular"
            className={classes.mobileBadge}
          />
        )}
        {badgeDot && !(badge > 0) && (
          <Badge
            variant="dot"
            color="error"
            overlap="rectangular"
            className={classes.mobileBadge}
          />
        )}
      </div>
    );
  }

  const posClass = positionClassMap[_position] || "itemOnly";

  const content = (
    <div className={cx(classes.item, classes[posClass])} onClick={onClick}>
      <span className={classes.icon}>{icon}</span>
      {badge > 0 && <span className={classes.desktopBadge}>{badgeLabel}</span>}
      {badgeDot && !(badge > 0) && <span className={classes.desktopBadgeDot} />}
      {label && <span className={classes.label}>{label}</span>}
      {children}
    </div>
  );

  if (tooltipTitle !== undefined) {
    return (
      <Tooltip
        title={tooltipTitle}
        placement="bottom"
        open={tooltipOpen}
        onOpen={onTooltipOpen}
        onClose={onTooltipClose}
      >
        {content}
      </Tooltip>
    );
  }

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="bottom">
        {content}
      </Tooltip>
    );
  }

  return content;
}

FloatingToolbarItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node,
  mobileLabel: PropTypes.string,
  badge: PropTypes.number,
  badgeDot: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipTitle: PropTypes.string,
  tooltipOpen: PropTypes.bool,
  onTooltipOpen: PropTypes.func,
  onTooltipClose: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.node,
  _position: PropTypes.string,
  _mobile: PropTypes.bool,
};
